import { Skeleton } from "antd";
import parse from "html-react-parser";
import moment from "moment";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import time from "../../assets/icon/Clip path group.png";
import articlesWebService from "../../services/webService/ArticleWebService";
import article_thumb from "../../assets/images/article_thumb_1.png";
const SingleNews = () => {
    const [articles, setArticles] = useState({});
    const [relatedArticles, setRelatedArticles] = useState([]);
    const location = useLocation();
    const ArticlesSlug = location.pathname.split("/")[2];
    const formatDate = (date) => moment.utc(date).format("DD-MM-YYYY HH:mm:ss");

    useEffect(() => {
        window.scrollTo(0, 0);
        try {
            const data = articlesWebService.getArticle(ArticlesSlug);
            data.then((res) => {
                if (res?.status === 200) {
                    setArticles(res?.article);
                    setRelatedArticles(res?.related_articles);
                } else {
                    toast.warn(res?.message);
                }
            });
        } catch (error) {
            toast.error(error);
        }
    }, [ArticlesSlug]);

    return (
        <div className="section-top">
            <div className="container">
                <div className="row my-5">
                    <div className="col-md-5 col-12 pe-md-4 pe-none mb-4">
                        <div className="d-flex flex-column justify-content-center">
                            {/* {articles?.image && articles?.title && articles?.description ? (
                                <>
                                    <img src={articles?.image} className="img-fluid img-single" alt="img" />

                                    <h4 className="fs-6 text-hover text-uppercase text-limit mt-3" style={{ height: "40px" }}>
                                        {articles?.title}
                                    </h4>
                                    <p className="text-lowercase my-2 text-secondary text-limit">{articles?.description}</p>
                                    <div className="d-flex align-items-center">
                                        <img src={time} className="img-fluid me-2" alt="" />
                                        <span className="text-secondary">{formatDate(articles?.created_at)}</span>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <Skeleton.Image active={true} className="w-100" style={{ height: "400px" }} />
                                    <div className="mt-3">
                                        <Skeleton
                                            paragraph={{
                                                rows: 4,
                                            }}
                                            title={false}
                                        />
                                    </div>
                                </>
                            )} */}
                            <>
                                <img src={article_thumb} className="img-fluid img-single" alt="img" />

                                <h4 className="fs-6 text-hover text-uppercase text-limit mt-3" style={{ height: "40px" }}>
                                    Yêu cầu cập nhật thông tin Ví Hpay
                                </h4>
                                <p className="text-lowercase my-2 text-secondary text-limit">Rà soát, cập nhật và bổ sung thông tin định danh Ví điện tử Hpay</p>
                                <div className="d-flex align-items-center">
                                    <img src={time} className="img-fluid me-2" alt="" />
                                    <span className="text-secondary">{"10-10-2026"}</span>
                                </div>
                            </>
                        </div>
                    </div>
                    <div className="col-md-7 col-12">
                        {/* <h2 className="fs-1 fw-bold">{articles?.title}</h2>
                        <p className="text-secondary my-3">{articles?.description}</p>
                        <div>{!!articles?.content ? parse(articles?.content) : null}</div> */}
                        <>
                            <p
                                style={{
                                    textIndent: "36pt",
                                    margin: "0cm 0cm 8pt",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: "Calibri, sans-serif"
                                }}
                            >
                                <span style={{ fontSize: "14pt" }}>
                                    <strong>
                                        <span style={{ fontFamily: '"Times New Roman", serif' }}>
                                            V/v: Rà soát, cập nhật và bổ sung thông tin định danh Ví điện tử Hpay
                                        </span>
                                    </strong>
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "36pt",
                                    margin: "0cm 0cm 8pt",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: "Calibri, sans-serif"
                                }}
                            >
                                <span style={{ fontSize: "14pt" }}>
                                    <strong>
                                        <span style={{ fontFamily: '"Times New Roman", serif' }}>
                                            Kính gửi Quý Khách hàng,
                                        </span>
                                    </strong>
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "36pt",
                                    margin: "0cm 0cm 8pt",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: "Calibri, sans-serif"
                                }}
                            >
                                <span style={{ fontFamily: '"Times New Roman", serif', fontSize: "14pt" }}>
                                    Nhằm tuân thủ quy định tại Thông tư số 40 của Ngân hàng Nhà nước Việt Nam
                                    về việc rà soát, chuẩn hóa thông tin khách hàng sử dụng ví điện tử, HTP
                                    trân trọng thông báo:
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "36pt",
                                    margin: "0cm 0cm 8pt",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: "Calibri, sans-serif"
                                }}
                            >
                                <span style={{ fontSize: "14pt" }}>
                                    <strong>
                                        <span style={{ fontFamily: '"Times New Roman", serif' }}>
                                            Kể từ ngày 10/10/2026
                                        </span>
                                    </strong>
                                    <span style={{ fontFamily: '"Times New Roman", serif' }}>
                                        , HTP triển khai rà soát và chuẩn hóa thông tin định danh đối với các Ví
                                        điện tử Hpay. Theo đó, đối với các Ví điện tử Hpay chưa được cập nhật
                                        đầy đủ hình ảnh mặt trước và mặt sau của Căn cước công dân (CCCD), HTP
                                        sẽ yêu cầu Khách hàng thực hiện xác thực lại thông tin định danh điện tử
                                        (eKYC) trên ứng dụng Hpay.
                                    </span>
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "36pt",
                                    margin: "0cm 0cm 8pt",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: "Calibri, sans-serif"
                                }}
                            >
                                <span style={{ fontFamily: '"Times New Roman", serif', fontSize: "14pt" }}>
                                    Để đảm bảo tuân thủ quy định và duy trì việc sử dụng dịch vụ không bị gián
                                    đoạn, kính đề nghị Quý Khách hàng truy cập ứng dụng <strong>Hpay</strong>{" "}
                                    trên App Store hoặc Google Play để thực hiện xác thực lại danh tính (eKYC)
                                    và bổ sung đầy đủ hình ảnh CCCD theo hướng dẫn.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "36pt",
                                    margin: "0cm 0cm 8pt",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: "Calibri, sans-serif"
                                }}
                            >
                                <span style={{ fontSize: "14pt" }}>
                                    <strong>
                                        <span style={{ fontFamily: '"Times New Roman", serif' }}>
                                            Trong thời hạn 30 ngày kể từ ngày HTP gửi thông báo
                                        </span>
                                    </strong>
                                    <span style={{ fontFamily: '"Times New Roman", serif' }}>
                                        , nếu Quý Khách hàng chưa hoàn tất việc cập nhật thông tin theo yêu cầu,
                                        HTP sẽ tiến hành đóng Ví điện tử theo quy định và liên hệ để thực hiện
                                        hoàn trả số dư còn lại (nếu có).
                                    </span>
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "36pt",
                                    margin: "0cm 0cm 8pt",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: "Calibri, sans-serif"
                                }}
                            >
                                <span style={{ fontSize: "14pt" }}>
                                    <strong>
                                        <span style={{ fontFamily: '"Times New Roman", serif' }}>
                                            Thông tin hỗ trợ và tra soát:
                                        </span>
                                    </strong>
                                    <span style={{ fontFamily: '"Times New Roman", serif' }}>
                                        {" "}
                                        Tổng đài 1900 0128.
                                    </span>
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "36pt",
                                    margin: "0cm 0cm 8pt",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: "Calibri, sans-serif"
                                }}
                            >
                                <span style={{ fontSize: "14pt" }}>
                                    <strong>
                                        <span style={{ fontFamily: '"Times New Roman", serif' }}>
                                            Lưu ý bảo mật:
                                        </span>
                                    </strong>
                                    <span style={{ fontFamily: '"Times New Roman", serif' }}>
                                        {" "}
                                        HTP không yêu cầu Quý Khách hàng cung cấp mật khẩu hoặc mã OTP cho nhân
                                        viên dưới bất kỳ hình thức nào.
                                    </span>
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "36pt",
                                    margin: "0cm 0cm 8pt",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: "Calibri, sans-serif"
                                }}
                            >
                                <span style={{ fontFamily: '"Times New Roman", serif', fontSize: "14pt" }}>
                                    HTP trân trọng cảm ơn sự hợp tác của Quý Khách hàng!
                                </span>
                            </p>
                        </>

                    </div>
                </div>
                {/* <div className="row my-5">
                    <div className="col-12">
                        <h2 className="fs-1 fw-bold">Tin liên quan</h2>
                    </div>
                    <div className="col-12 mt-4">
                        <div className="row">
                            {relatedArticles?.map((relatedArticle) => (
                                <Link
                                    key={relatedArticle.id}
                                    to={`/bai-viet/${relatedArticle.slug}`}
                                    className="col-12 col-md-6 col-lg-4 mb-5 mb-lg-none card-custom"
                                >
                                    <button className="btn-card">Xem ngay</button>

                                    <div className="d-flex flex-column justify-content-center">
                                        <img src={relatedArticle.thumbnail_url} className="img-fluid img-card" alt="img" />

                                        <h4 className="fs-6 text-hover text-uppercase text-limit mt-3" style={{ height: "40px" }}>
                                            {relatedArticle.title}
                                        </h4>
                                        <p className="text-lowercase my-2 text-secondary text-limit">{relatedArticle.description}</p>
                                        <div className="d-flex align-items-center">
                                            <img src={time} className="img-fluid me-2" alt="" />
                                            <span className="text-secondary">{formatDate(relatedArticle.created_at)}</span>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default SingleNews;
